<div
  class="flex message-bubble"
  [ngClass]="{ 'justify-end': isSender, 'justify-start': !isSender }"
>
  <div class="flex gap-1 items-end w-full" [ngClass]="{ 'flex-row-reverse': isSender }">

    <!-- Bubble -->
    <div class="w-80-prc bubble-wrapper">
      <div
        [ngClass]="{
          'bg-owner': isSender,
          'bg-contact': !isSender
        }"
      >
        <!-- Sender name row with optional note indicator -->
        <div class="bubble-name-row" [ngClass]="{'justify-end': isSender}">
          <span class="bubble-sender-name">{{ senderName }}</span>
          <button
            *ngIf="message.note"
            class="note-indicator"
            (click)="$event.stopPropagation(); toggleNotePreview()"
            title="Mostra nota"
          >
            <i class="fa-light fa-circle-exclamation"></i>
          </button>
        </div>

        <app-message-reply
          *ngIf="message.replyMessage"
          [reply]="message.replyMessage"
        ></app-message-reply>

        <app-message-renderer [message]="message" />

        <button *ngIf="!disableActions" class="bubble-caret"
          [class.bubble-caret--left]="isSender"
          [class.bubble-caret--right]="!isSender"
          (click)="toggleMenu()">
          <i class="fa-solid fa-chevron-down"></i>
        </button>

        <!-- Note preview: absolutely positioned to the side, like bubble-menu -->
        @if (notePreviewOpen && message.note) {
          <div class="note-bubble"
            [class.note-bubble--left]="isSender"
            [class.note-bubble--right]="!isSender"
            (click)="$event.stopPropagation()">
            <p-message severity="warn" styleClass="note-bubble-msg">{{ message.note }}</p-message>
          </div>
        }

        <div *ngIf="menuOpen && !disableActions" class="bubble-menu"
          [class.bubble-menu--left]="isSender"
          [class.bubble-menu--right]="!isSender"
          (click)="$event.stopPropagation()">
          <button class="bubble-menu__item" (click)="onReply()">
            <i class="fa-solid fa-reply"></i>
            <span>Rispondi</span>
          </button>
          <button class="bubble-menu__item bubble-menu__item--disabled" disabled>
            <i class="fa-solid fa-reply-all"></i>
            <span>Inoltra</span>
          </button>
          <button
            class="bubble-menu__item"
            [class.bubble-menu__item--disabled]="!message.replyMessage"
            [disabled]="!message.replyMessage"
            (click)="onViewContext()">
            <i class="fa-solid fa-comment"></i>
            <span>Contesto</span>
          </button>
          <button class="bubble-menu__item" (click)="openNote()">
            <i class="fa-light fa-note-sticky"></i>
            <span>Nota</span>
          </button>
        </div>
      </div>
    </div>

  </div>
</div>

@if(message.failedToSend){
  <p-message severity="error" size="small" class="float-end mt-2" icon="pi pi-exclamation-triangle">Invio Fallito</p-message>
}

<!-- Note edit panel (full overlay) -->
@if (noteOpen) {
  <div class="note-overlay" (click)="closeNote()">
    <div class="note-card" (click)="$event.stopPropagation()">
      <div class="note-header">
        <div>
          <div class="note-title">
            <i class="fa-light fa-note-sticky"></i>
            Note del messaggio
          </div>
          <div class="note-subtitle">Visibili solo agli operatori · non inviate al contatto</div>
        </div>
        <span class="note-save-status">
          @if (noteSaveStatus === 'saving') {
            <i class="pi pi-spin pi-spinner"></i> Salvataggio…
          } @else if (noteSaveStatus === 'saved') {
            <i class="pi pi-check"></i> Salvato
          }
        </span>
        <p-button icon="pi pi-times" text rounded size="small" severity="secondary" (onClick)="closeNote()"/>
      </div>
      <div class="note-body">
        <textarea
          [(ngModel)]="noteText"
          (ngModelChange)="onNoteInput($event)"
          class="note-textarea"
          placeholder="Scrivi una nota…"
        ></textarea>
      </div>
    </div>
  </div>
}
